import { Component } from '@angular/core';
import { RidButton } from '../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-syllabic-keyboard-page',
  imports: [RidDemoPage, RidButton],
  templateUrl: './syllabic-keyboard-page.html',
})
export class SyllabicKeyboardPage {}
